import { Injectable } from '@angular/core';
import { addDays, formatISO, getHours, setHours, startOfDay, subDays } from 'date-fns';

@Injectable({
	providedIn: 'root'
})
export class ClinicalDayService {

	constructor() {
	}

	hoursToClinicalDayIsoDateString(currentDate: string | Date, hours: number): string {
		var date: Date;
		if (getHours(currentDate) < 6) {
			date = hours < 6 ? setHours(startOfDay(currentDate), hours) : subDays(setHours(startOfDay(currentDate), hours), 1);
		}
		else {
			date = hours < 6 ? addDays(setHours(startOfDay(currentDate), hours), 1) : setHours(startOfDay(currentDate), hours);
		}
		return formatISO(date);
	}
}